import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Pagination, notification, Space } from 'antd';
import AddSystemAdminForm from './component/AddSystemAdminForm';
import SystemAdminList from './component/SystemAdminList';

const SystemAdminReg = () => {
    
    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    const [allSysAdminData, setAllSysAdminData] = useState([]);
    const [editSingleData, setEditSingleData] = useState([]);
    const [systemAdminId, setSystemAdminId] = useState(null);
    const [loaderStatus, setLoaderStatus] = useState(false);
    const [totalRecord, setTotalRecord] = useState(0);
    const [page, setPage] = useState(1);
    const dataLimit = 20;
    
    useEffect(()=>{
        getAllSystemAdmin();
    },[])

    const getAllSystemAdmin = async(event, page_no) => {
        try {
            setLoaderStatus(true);
            let apiToken = '';
            if(loginUserType === 'A') {
                apiToken = localStorage.getItem('token')
            } else if(loginUserType === 'SA') {
                apiToken = localStorage.getItem('systemAdminToken')
            }
            const api_params = {};
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };
            if(event) {
                api_params.search_data = event.target.value;
            }
            api_params.page = page_no ? page_no : page;;
            api_params.limit = dataLimit;
            api_params.sys_admin_id = systemAdminId;

            await axios.post(`${api_base_url}admin/get-all-system-admin`, api_params, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        setLoaderStatus(false);
                        if(systemAdminId) {
                            setEditSingleData(res.data.data.allSysAdminData[0]);
                            setSystemAdminId('');
                        } else {
                            setAllSysAdminData(res.data.data.allSysAdminData);
                            setTotalRecord(res.data.data.paginationData.total_count);
                        }
                    }
                })
                .catch((error) => {
                    setLoaderStatus(false);
                }) 
        } catch (error) {
            setLoaderStatus(false);
        } finally {
            setLoaderStatus(false);
        }
    }

    const handelRecordInserted = (event) => {
        //setAllSysAdminData(prevState => ([event, ...prevState]));
        getAllSystemAdmin();
    }

    const handelRecordDeleted = (event) => {
        setAllSysAdminData((prevState) => prevState.filter((item) => item.system_admin_id !== event.system_admin_id));
    };

    const handelEditSystemAdmin = (event) => {
        setSystemAdminId(event.system_admin_id);
    }

    const handelRecordUpdated = (newData) => {
        // const updatedData = allSysAdminData.map(sysadmin =>
        //     sysadmin.system_admin_id === newData.unique_id
        //         ? { ...sysadmin, ...newData }
        //         : sysadmin
        // );
        // setAllSysAdminData(updatedData);
        //setSystemAdminId('');
        // setEditSingleData([]);
        getAllSystemAdmin();
    }

    useEffect(()=>{
        if(systemAdminId) getAllSystemAdmin();
    },[systemAdminId])

    const onChange = (page) => {
        setPage(page);
        // getAllWidget(null, page);
    };

    return (
        <>
        <AddSystemAdminForm recordInserted={handelRecordInserted} recordUpdated={handelRecordUpdated} updateData={editSingleData} sysAdminSearchInput={getAllSystemAdmin} totalRecords={totalRecord} />
        <SystemAdminList allSysAdmin={allSysAdminData} systemAdminDeleted={handelRecordDeleted} sysAdminEditId={handelEditSystemAdmin} />
        {/* <AddSystemAdminForm recordInserted={handelRecordInserted} widgetId={widgetId} recordUpdated={handelRecordUpdated} totalRecords={totalRecord} searchWidget={getAllWidget} loader_status={loaderStatus} /> */}
        {/* <WidgetList allWidgets={allWidgetData} widgetDeleted={handelRecordDeleted} widgetEditId={handelEditWidget} /> */}

        <div className="row mt-5">
            <Pagination 
                align="end" 
                defaultPageSize={20}
                defaultCurrent={1} 
                current={page} 
                onChange={onChange}
                total={totalRecord}  
                hideOnSinglePage={false}
            />
        </div>
        </>
    )
}

export default SystemAdminReg;